<template>
  <popup-special
    v-model="popStatus"
    title="优惠券"
    @closed="handleClosed"
    :lazyRender="false"
  >
    <ul class="mt48 mb30">
      <li v-for="item in inList" :key="item.muuid">
        <coupon-item-with-checkbox
          :couponInfo="item"
          @onSelect="handleChange"
        ></coupon-item-with-checkbox>
      </li>
    </ul>
  </popup-special>
</template>
<script>
import PopupSpecial from '@/components/action-sheet/popup-special'
import CouponItemWithCheckbox from '../../coupon/item-width-checkbox'
import { createNamespacedHelpers } from 'vuex'
const { mapMutations, mapState } = createNamespacedHelpers('promotionInfo')
export default {
  inject: {
    changeCouponTrackParams: {
      default: null
    }
  },
  props: {
    inList: Array
  },
  data() {
    return {
      popStatus: false
      // list: this.inList,
    }
  },
  computed: {
    ...mapState(['selPromInfo'])
  },
  methods: {
    ...mapMutations(['setSelectedCoupon']),
    handleClosed() {
      console.log('222222closed')
    },
    show() {
      this.popStatus = true
    },
    handleChange({ couponInfo }) {
      this.changeCouponTrackParams &&
        this.$$newTrackClick(this.changeCouponTrackParams)
      this.setSelectedCoupon(couponInfo)
    }
  },
  // watch: {
  //   inList(n) {
  //     this.list = n
  //   },
  // },
  components: {
    PopupSpecial,
    CouponItemWithCheckbox
  }
}
</script>
<style lang="scss" scoped>
ul {
  li {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
